var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#383330}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "29.48433 28.41443 24.83625 20.98897 29.32827 20.98897 29.32827 15.37466 6.67111 15.37466 6.67111 20.98897 11.16303 20.98897 6.51505 28.41443 12.25253 31.6419 17.99969 21.42514 23.74686 31.6419 29.48433 28.41443"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.62647,5.3355l-.73136.31114c-2.81753,1.19915-5.81051,1.80734-8.89552,1.80734-3.0856,0-6.07779-.60819-8.89474-1.80734l-.73185-.31134-2.15265,5.24119.68505.29186c3.5156,1.49678,7.24835,2.25594,11.09419,2.25594s7.57869-.75916,11.09507-2.25594l.68456-.29156s-2.15275-5.24129-2.15275-5.24129Z"
  })))));
};
export default SvgIcon;